<template>
  <div style="width:100%;height:100%; padding-top:16px;position:relative;">
    <!-- <input
      v-model="rangeVal"
      ref="swipe"
      type="range"
      style="width: 100%;top:0px;left:0px;position:absolute;"
      @input="changeDivider"
    > -->
    <a-slider
      ref="swipe"
      :default-value="50"
      v-model="rangeVal"
      style="width: 100%;top:0px;left:0px;position:absolute;margin:2px;"
      @change="changeDivider"
      :tooltip-visible="false"
    />

    <a-select
      style="position:absolute;top:20px;left:10px;width:150px;z-index:1000;"
      :options="swipeLayers"
      v-model="selectedSwipLayer.left"
      placeholder="请选择图层"
      @change="leftLayerChange"
    >
    </a-select>
    <a-select
      style="position:absolute;top:20px;right:10px;width:150px;z-index:1000;"
      :options="swipeLayers"
      v-model="selectedSwipLayer.right"
      placeholder="请选择图层"
      @change="rightLayerChange"
    >
    </a-select>
    <a-button
      style="z-index:1000;right:10px;bottom:10px;position:absolute;"
      type="primary"
      @click="exitCurrent()"
    >
      退出多时相分析
    </a-button>

    <div
      id="swipeDiv"
      class="dd-map"
    >
    </div>
  </div>
</template>
<script>
import "ol/ol.css";
import TileWMS from 'ol/source/TileWMS';
import { Map, View } from "ol";
import Projection from 'ol/proj/Projection';
import { register } from 'ol/proj/proj4';
import * as olControl from 'ol/control';
import TileLayer from 'ol/layer/Tile';
import ImageLayer from 'ol/layer/Image';
import VectorLayer from 'ol/layer/Vector';
import VectorSource from 'ol/source/Vector';
import Feature from 'ol/Feature';
import Static from 'ol/source/ImageStatic';
import { Style, Fill, Stroke, Circle, Icon } from 'ol/style';
import Polygon from 'ol/geom/Polygon';
import Point from 'ol/geom/Point';
import { fromCircle } from 'ol/geom/Polygon';
import proj4 from 'proj4';
import Header from '@/components/Header';
import { getRenderPixel } from 'ol/render';
import epsg9900 from '../utils/epsgParams';


export default {
  name: 'Swipe',
  data() {
    return {
      swipeLayers: [],
      allLayersMap: {},
      rangeVal: 50,
      swipeMap: {},
      selectedSwipLayer: {
        left: undefined,
        right: undefined
      },
      initSwipeExtent: epsg9900.initExtent,

    }
  },
  methods: {
    exitCurrent() {
      this.$emit("exitCurrent");
    },
    leftLayerChange(val) {
      this.addSwipeWmsLayer(this.allLayersMap[val], "left");
    },
    rightLayerChange(val) {
      this.addSwipeWmsLayer(this.allLayersMap[val], "right");
    },
    initSwipeMap() {
      const projection = new Projection({
        code: "EPSG:990000",
        units: 'meters',
        extent: epsg9900.extent
      });
      const baseLayer = new ImageLayer({
        id: "base_layer_0",
        source: new Static({
          url: './img/basemap.png',
          projection: projection,
          imageExtent: this.initSwipeExtent,
          crossOrigin: "Anonymous",
          transition: 0
        })
      });

      this.swipeMap = new Map({
        target: 'swipeDiv',
        // layers: [baseLayer],
        controls: olControl.defaults({
          zoom: false
        }),
        view: new View({
          projection: projection,
          center: [521192.470947859, 279996.2693056469],
          zoom: 8,
          minZoom: 2,
          maxZoom: 16
        })
      });

      this.swipeMap.on("singleclick", (e) => {
        // console.log(e);
        const feature = this.swipeMap.forEachFeatureAtPixel(e.pixel, (feature, layer) => { return feature; });
      });

    },
    addSwipeWmsLayer(layerInfo, position) {
      let tileLayer;
      if (this.isPngLayer(layerInfo.geometry_type)) {
        tileLayer = new ImageLayer({
          id: position == "left" ? "leftLayer" : "rightLayer",
          visible: true,
          source: new Static({
            url: `${process.env.VUE_APP_STATIC_ROOT + layerInfo.key}/${layerInfo.key + layerInfo.geometry_type}`,
            imageExtent: layerInfo.bbox,
            transition: 0
          })
        });
      } else {
        tileLayer = new TileLayer({
          visible: true,
          id: position == "left" ? "leftLayer" : "rightLayer",
          source: new TileWMS({
            url: process.env.VUE_APP_GEOSERVER_ROOT + "wms?",
            params: {
              'LAYERS': "chs:" + layerInfo.key,
              'TILED': true
            },
            serverType: 'geoserver',
            transition: 0
          })
        });
      }


      if (position == "left") {
        const l = this.getSwipeLayerById("leftLayer");
        if (l) {
          this.swipeMap.removeLayer(l);
        }
        tileLayer.on('prerender', (event) => {
          var ctx = event.context;
          var mapSize = this.swipeMap.getSize();
          var width = mapSize[0] * (this.rangeVal / 100);
          var tl = getRenderPixel(event, [width, 0]);
          var tr = getRenderPixel(event, [mapSize[0], 0]);
          var bl = getRenderPixel(event, [width, mapSize[1]]);
          var br = getRenderPixel(event, mapSize);

          ctx.save();
          ctx.beginPath();
          ctx.moveTo(0, tl[1]);
          ctx.lineTo(0, bl[1]);
          ctx.lineTo(tl[0], bl[1]);
          ctx.lineTo(tl[0], tl[1]);
          ctx.closePath();
          ctx.clip();
        });

        tileLayer.on('postrender', (event) => {
          var ctx = event.context;
          ctx.restore();
        });
      } else {
        const l = this.getSwipeLayerById("rightLayer");
        if (l) {
          this.swipeMap.removeLayer(l);
        }
        tileLayer.on('prerender', (event) => {
          var ctx = event.context;
          var mapSize = this.swipeMap.getSize();
          var width = mapSize[0] * (this.rangeVal / 100);
          var tl = getRenderPixel(event, [width, 0]);
          var tr = getRenderPixel(event, [mapSize[0], 0]);
          var bl = getRenderPixel(event, [width, mapSize[1]]);
          var br = getRenderPixel(event, mapSize);

          ctx.save();
          ctx.beginPath();
          ctx.moveTo(tl[0], tl[1]);
          ctx.lineTo(bl[0], bl[1]);
          ctx.lineWidth = 5;
          ctx.strokeStyle = "red"
          ctx.stroke()
          ctx.lineTo(br[0], br[1]);
          ctx.lineTo(tr[0], tr[1]);
          ctx.closePath();
          ctx.clip();
        });

        tileLayer.on('postrender', (event) => {
          var ctx = event.context;
          ctx.restore();
        });

      }
      this.swipeMap.addLayer(tileLayer);
    },
    changeDivider() {
      this.swipeMap.render();
    },
    isPngLayer(ext) {
      if (".png".toLowerCase() == ext || ".jpg".toLowerCase() == ext || ".jpeg".toLowerCase() == ext) {
        return true;
      }
      return false;
    },
    getSwipeLayerById(id) {
      for (let l of this.swipeMap.getLayers().getArray()) {
        if (l.get("id") == id) {
          return l;
        }
      }
      return undefined;
    },
  },
  mounted() {
    let self = this;
    this.$nextTick(() => {
      this.$on("initMap", (allLayers) => {
        self.$store.commit('setLoadingVisible', true);
        setTimeout(() => {
          this.allLayersMap = allLayers;
          this.swipeLayers = Object.keys(allLayers).map(key => {
            return { label: allLayers[key].name, value: allLayers[key].key };
          });
          this.rangeVal = 50;
          this.selectedSwipLayer.left = undefined;
          this.selectedSwipLayer.right = undefined;
          document.getElementById("swipeDiv").innerHTML = "";
          this.initSwipeMap();
          self.$store.commit('setLoadingVisible', false);
        }, 1000);
      })
    })

  }
}
</script>
<style scoped>
.dd-map {
  width: 100%;
  height: 100%;
  position: relative;
}
</style>
<style lang="scss">
.ant-slider-rail {
  background-color: #888888;
}
</style>